import React from 'react';
import LazyPageLoader from '../../cmp/LazyPageLoader';
import {useSelector} from "react-redux";

const Page = React.lazy(()=>import('./TransactionsIndex'))

export default function TransactionsIndexLazy(){
    const aff_show_transactions = useSelector<any>((state)=>state.settings?.aff_show_transactions)
    if(!aff_show_transactions) return null;
    return <React.Suspense fallback={<LazyPageLoader />}>
        <Page />
    </React.Suspense>
}


